import {getNextDay} from "./util";

export function findReplaceArticleStep(item) {
  if (item && item.extras && item.extras.variants) {
    for (let step of item.extras.variants) {
      if (step.replaceArticle) {
        return step;
      }
    }
  }

  return null;
}

export function itemsContainsTicket(items) {
  try {
    for (let item of items) {
      if (!!item.ticket) {
        return true;
      }
    }
  } catch (e) {

  }
  return false;
}

export function appendCategoryNameToMenuItems(menu) {
  menu.forEach(category => {
    if (!category) {
      return
    }
    // Holen uns den Namen der aktuellen Kategorie
    const categoryName = category.categoryDE;

    // Überprüfen, ob überhaupt Items in dieser Kategorie existieren
    if (category.items && Array.isArray(category.items)) {
      category.items.forEach(item => {
        if (item) {
          // Füge die Eigenschaft 'categoryDE' direkt dem Item-Objekt hinzu
          item.categoryDE = categoryName;
          console.log('added categoryDE to item ' + item.categoryDE);
        }
      });
    }
  });
  return menu;
}
